query CompanyConfigurationWarning {
  companyConfigurationWarning
}
